import { Component, EventEmitter, inject, Output, signal, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { passwordValidator } from '../../../../_core/validators/password.validator';
import { confirmPasswordValidator } from '../../../../_core/validators/confirmPassword.validator';
import { AutoFocusErrorDirective } from '../../../directives/auto-focus-error.directive';
import { ToastService } from 'src/app/_core/services/toast.service';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'opac-reset-password-dialog',
  templateUrl: './reset-password-dialog.component.html',
  styleUrls: ['./reset-password-dialog.component.scss']
})
export class ResetPasswordDialogComponent {
  private readonly toastService = inject(ToastService);
  private readonly apiService = inject(ApiService);

  @ViewChild(AutoFocusErrorDirective) autoFocusError: AutoFocusErrorDirective;
  @Output() submit = new EventEmitter<boolean>();
  
  readonly form: FormGroup;
  readonly open = signal<boolean>(false);
  readonly code = signal<string>('');

  get newPasswordControl() {
    return this.form.get('newPassword');
  }

  get confirmPasswordControl() {
    return this.form.get('confirmPassword');
  }

  constructor() {
    const newPasswordControl = new FormControl('', [Validators.required, passwordValidator()]);
    const confirmPasswordControl = new FormControl('', [Validators.required, confirmPasswordValidator(newPasswordControl)]);

    this.form = new FormGroup({
      newPassword: newPasswordControl,
      confirmPassword: confirmPasswordControl,
    });

    this.newPasswordControl?.valueChanges.subscribe(() => {
      this.confirmPasswordControl?.updateValueAndValidity();
    });
  }

  openModal(code: string) {
    this.code.set(code);
    this.form.reset();
    this.open.set(true);
  }

  closeModal() {
    this.open.set(false);
  }

  validatePasswords() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.autoFocusError.check();
      return;
    }

    this.apiService.resetPassword(this.code(), this.newPasswordControl.value).subscribe(() => {
      this.toastService.showToast('messages.login.reset');
      this.open.set(false);
      this.submit.emit(true);
    });
  }
}
